export default [{
  name: 'name',
  validation: [
    name => !name && 'A title for the event is required.',
    name => name && name.length > 80 && 'The title must be less than 80 characters.',
  ],
}, {
  name: 'image',
  validation: [
    (image, values, props) => props.isUploadingImage && 'Please wait until the image has finished uploading.',
    (image, values, props) => !props.imageId && 'An image for the event is required.',
  ],
}, {
  name: 'tagline',
  validation: [
    tagline => !tagline && 'A tagline for the event is required.',
    tagline => tagline && tagline.length > 85 && 'The tagline must be less than 85 characters.',
  ],
}, {
  name: 'description',
  validation: [
    description => !description && 'A description for the event is required.',
  ],
}, {
  name: 'rawOfferText',
  validation: [
    rawOfferText => rawOfferText && rawOfferText.length > 24
      && 'The offer description must be less than 24 characters.',
  ],
}, {
  name: 'venueAddress',
  validation: [],
}, {
  name: 'venueId',
  validation: [
    (venueId, values, props) =>
      !props.newVenueCreation && values.venueName && !values.venueAddress && 'A venue address is required.',
    (venueId, values, props) =>
      !props.newVenueCreation && !values.venueName && values.venueAddress && 'A venue name is required.',
    (venueId, values, props) =>
      !props.newVenueCreation && !venueId &&
      !(values.venueName && values.venueAddress) && 'A venue for the event is required.',
    (venueId, values, props) =>
      props.newVenueCreation && !venueId && props.newVenue && !props.newVenue.name && 'A venue name is required.',
    (venueId, values, props) =>
      props.newVenueCreation && !venueId &&
      props.newVenue && !props.newVenue.address1 && 'A venue address is required.',
    (venueId, values, props) =>
      props.newVenueCreation && !venueId &&
      props.newVenue && !props.newVenue.city && 'A venue city is required.',
    (venueId, values, props) =>
      props.newVenueCreation && !venueId &&
      props.newVenue && !props.newVenue.postal_code && 'A venue postcode or zipcode is required.',
    (venueId, values, props) =>
      props.newVenueCreation && !venueId && props.newVenue === null && 'A venue for the event is required.',
  ],
}, {
  name: 'venueName',
  validation: [],
}, {
  name: 'eventTypeId',
  validation: [
    eventTypeId => !eventTypeId && 'An event type for the event is required',
  ],
}]



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/fields.js
 **/